<div class="ui-activity-graph__grid">
  <div class="ui-activity-graph__grid__weekdays">
    <br />
    ma
    <br />
    <br />
    wo
    <br />
    <br />
    vr
    <br />
    <br />
    zo
  </div>
  <div>
    <div class="ui-activity-graph__grid__months">
      @for (month of months; track $index) {
        <span [ngClass]="month.className">{{ month.month }}</span>
      }
    </div>
    <campus-grid-diagram
      [values]="activityGraphValues"
      [size]="'large'"
      [rows]="7"
      [showTooltip]="showTooltip"
      (clickChart)="chartClicked($event)"
    ></campus-grid-diagram>
  </div>
</div>
@if (title) {
  <div class="ui-activity-graph__title">{{ title }}</div>
}
@if (showLegend) {
  <div class="ui-activity-graph__legend">
    <span>weinig</span>
    @for (level of legend; track $index) {
      <i [style.opacity]="level.opacity" [ngClass]="level.className"></i>
    }
    <span>veel</span>
  </div>
}
